export default __webpack_public_path__ + "static/media/san_luis.ef0f555e.jpg";